// The canonical rule-id normaliser (R1). The agent supplies the `rule` citation as free
// text and the rubric prose instructs bracketed/prefixed forms, so the persisted log mixes
// `"6.3"`, `"[6.3]"`, `"[CR] 6.3"`, and `"[P.1]"`. Any per-rule aggregate must collapse those
// notations onto one bare dotted/`letter.`-prefixed id (`6.3`, `11.1`, `P.1`, `G.1`). This pure,
// idempotent function is applied at the write/reclassify decode boundary, inside every
// read projection, and by the rubric catalog parser, so a single notation reaches storage
// and every cohort.
//
// `manual:*` operational sentinels are not rule citations and pass through unchanged;
// unrecognised free text is returned trimmed (never thrown) so an odd citation degrades to
// its own cohort rather than failing a write.

const SENTINEL_PREFIX = "manual:";
const SOURCE_PREFIX = /^\[[^\]]*\]\s+(.+)$/;
const SURROUNDING_BRACKETS = /^\[(.+)\]$/;

export const canonicalizeRuleId = (raw: string): string => {
  let id = raw.trim();
  if (id.startsWith(SENTINEL_PREFIX)) return id;
  const prefixed = SOURCE_PREFIX.exec(id);
  if (prefixed?.[1] !== undefined) id = prefixed[1].trim();
  const bracketed = SURROUNDING_BRACKETS.exec(id);
  if (bracketed?.[1] !== undefined) id = bracketed[1].trim();
  return id;
};
